import React, { useState, useEffect } from 'react';
import { importMatches, postV2Competitions } from "../../../api/index.js";
import { checkImportMatches } from "../../../api/index.js";

// import options
import { useDropzone } from 'react-dropzone';
import PasteTableComponent from './utils/PasteTableComponent.js';

import * as XLSX from 'xlsx';

// MUI COMPONENTS
import { Accordion, AccordionSummary, AccordionDetails, Typography, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';

//ICONS
import ForwardIcon from '@mui/icons-material/Forward';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';


import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import DoneIcon from '@mui/icons-material/Done';
import UpdateIcon from '@mui/icons-material/Update';
import ErrorIcon from '@mui/icons-material/PriorityHigh';
import InfoIcon from '@mui/icons-material/Info';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DisciplineDTO from '../../../v2/DTO/DisciplineDTO.js';
import EpreuveDTO from '../../../v2/DTO/EpreuveDTO.js';
import CategoryDTO from '../../../v2/DTO/CategoryDTO.js';
import SportEventDTO from '../../../v2/DTO/SportEventDTO.js';
import CompetitionDTO from '../../../v2/DTO/CompetitionDTO.js';
import PhaseDTO from '../../../v2/DTO/PhaseDTO.js';


const dropzoneStyles = {
  border: '2px dashed #ccc',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
};

const ColumnMappingComponent = ({ commonColumns, requiredColumns, onColumnMappingChange, prevColumnMapping, prevMappedColumns, headerRow, showInfoMsg }) => {
  const [showEventAccordion, setShowEventAccordion] = useState(false);
  const [columnMappings, setColumnMappings] = useState({});
  const [mappedColumns, setMappedColumns] = useState({});
  const [isMappingValid, setIsMappingValid] = useState(false);

  // Extract available choices
  const availableChoices = headerRow;

  if (Object.keys(columnMappings).length === 0 && Object.keys(prevColumnMapping).length > 0 && Object.keys(mappedColumns).length === 0 && Object.keys(prevMappedColumns).length > 0){

    setColumnMappings((prevMappings) => ({
      ...prevMappings,
      ...prevColumnMapping
      }));
    
    setMappedColumns((prevMappings) => ({
        ...prevMappings,
        ...prevMappedColumns
        }));
}

  // column mapping validation
  const checkIfMappingValid = (currentMapping) => {
    const sortedUpdatedMappings = Object.fromEntries(Object.entries(currentMapping).sort((a, b) => requiredColumns.indexOf(a[0]) - requiredColumns.indexOf(b[0])));
    const sortedRequiredColumns = requiredColumns.sort();
    const isValid = sortedRequiredColumns.every((column) => sortedUpdatedMappings[column] !== undefined && sortedUpdatedMappings[column] !== null);
    return isValid;
  };

   // UseEffect to trigger validation after state update
   useEffect(() => {
    // Check if all mandatory columns are mapped
    const isValid = checkIfMappingValid(mappedColumns);
    setIsMappingValid(isValid);
  }, [mappedColumns]);


  const handleMappingChange = (columnName, mappedValue) => {

  
    setColumnMappings((prevMappings) => ({
      ...prevMappings,
      [columnName]: mappedValue,
    }));


    setMappedColumns((prevMappings) => {
      const updatedMappings = {
        ...prevMappings,
        [columnName]: headerRow.indexOf(mappedValue),
      };

      // Check if all mandatory columns are mapped
      const isValid = checkIfMappingValid(updatedMappings);
      setIsMappingValid(isValid);
      return updatedMappings;
  });

  };

  const handleApplyMapping = () => {
    
    // If validation is OK, give mapping to parent component
    if (isMappingValid) {
      onColumnMappingChange(columnMappings, mappedColumns, isMappingValid);
      setShowEventAccordion(true);
    } else {
      // update validation state
      setIsMappingValid(false);
    }
  };

  // Calculer la largeur maximale des labels
  const maxLabelWidth = Math.max(...commonColumns.map(columnName => columnName.length * 15)); // Ajustez la valeur multiplicatrice selon vos besoins


  return(
    <div>
    <div style={{ marginTop: '30px' }}>
    <h3 style={{ marginBottom: '20px' }}>{'Mapping des compétitions, équipes et joueurs'}</h3>
    {/* Error msg - validation fail */}
    {!isMappingValid && showInfoMsg && (
      <div style={{ color: 'red', marginTop: '10px', marginBottom: '20px' }}>
        Veuillez mapper toutes les colonnes obligatoires avant d'appliquer le mapping.
      </div>
    )}
    {commonColumns.map((columnName, index) => (
      <div key={columnName} style={{ marginBottom: '15px', display: 'flex'}}>
        <label style={{ width: `${maxLabelWidth}px`, marginRight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <span>{columnName}
        {requiredColumns.includes(columnName) && <span style={{ color: 'red', padding:'5px' }}>*</span>}</span>
        <ForwardIcon style={{ marginLeft: '5px' }} />
        </label>
        <select
          value={columnMappings[columnName] || ''}
          onChange={(e) => handleMappingChange(columnName, e.target.value)}
          style={{
            width: '50%',
            padding: '8px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            verticalAlign: 'middle'
          }}
        >
          <option value="" disabled>
            Choisir une colonne
          </option>
          {availableChoices.map((header, headerIndex) => (
            <option key={headerIndex} value={header}>
              {header}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>

  <div style={{ marginTop: '30px' }}>
 
    <button
      onClick={handleApplyMapping}
      disabled={!isMappingValid}
      style={{
        padding: '10px',
        borderRadius: '5px',
        background: isMappingValid ? '#0A76B9' : '#ccc',
        color: 'white',
        cursor: isMappingValid ? 'pointer' : 'not-allowed',
      }}
    >
      Appliquer le mapping
    </button>
  </div>
  </div>
  );
};

const EventAccordion = ({ eventData, oddBackground }) => {
  //removed Points, for now
  const { 
    'SportId' : sportId, 
    'SportLabel' : sportLabel, 
    'DisciplineId' : disciplineId, 
    'DisciplineLabel' : disciplineLabel,
    'Compétition': Competition, 
    'Phase' : Phase, 
    'Epreuve' : Epreuve, 
    'Catégorie' : Categorie, 
    'Date' : Date,
    'Provider' : Provider,
    'Config' : Config
  } = eventData;

  return (<div>
    
      <Box aria-controls="panel-content" id="panel-header"  style={{ padding : 2, backgroundColor: oddBackground ? '#d0d0d075' : 'transparent', borderBottom: '2px solid #80808070' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
        {(Provider && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Provider:</strong> {Provider}
              </div>)}
              {(Config && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Config:</strong> {Config}
              </div>)}
            {(sportLabel && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Sport:</strong> {sportId} {sportLabel}
              </div>)}
              {(disciplineLabel && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Discipline:</strong> {disciplineId} {disciplineLabel}
              </div>)}
            {(Competition && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Compétition:</strong> {Competition}
              </div>)}
              {(Phase && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Phase:</strong> {Phase}
              </div>)}
              {(Epreuve && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Epreuve:</strong> {Epreuve}
              </div>)}
              {(Categorie && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Catégorie:</strong> {Categorie}
              </div>)}
              {(Date && <div style={{ paddingRight: '10px', paddingLeft: '10px'}}>
                <strong>Date:</strong> {Date.toLocaleString()}
              </div>)}
        </div>
      </Box>
    </div>
  );
};


const Legend = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ display: 'flex', backgroundColor: 'rgb(128 128 128 / 10%)', padding: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} />
          <span>Création</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />
          <span>Mise à jour</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '5px' }}>
          {/*carré couleur : <div style={{ width: '20px', height: '20px', backgroundColor: '#cc0000', marginRight: '5px' }}></div>*/}
          <ErrorIcon style={{ color: '#cc0000' }} />
          <span>Erreur</span>
        </div>
      </div>
    </div>
  );
};

const ImportResume = ({ importSummary }) => {

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#e9e9e9',
        color: 'black',
        border: '1px solid #00000033',
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: '10px',
          marginBottom: '5px',
          alignItems: 'center',
          alignSelf: 'center'
        }}
      >
        <InfoIcon style={{ padding: '5px' }} />
        <span>Détail de l'import pour les events.</span>
      </div>

      {/* Afficher le résumé de l'importation */}
      {importSummary &&
        Object.entries(importSummary).map(([key, summary]) => (
          <div key={key} style={{ padding: '10px', borderBottom: '1px solid #ccc', alignItems: 'center', textAlign: 'center', color: summary.errorCount > 0 ? 'red' : 'black', /*Rouge si nb erreurs > 0*/ }}>
            <strong style={{padding:'5px'}}>{summary.name}</strong>
            Total: {summary.total}, Succès: {summary.successCount}, Erreurs: {summary.errorCount}
          </div>
        ))}

    </div>
  );
};


const CompetitionsAccordionCheckData = ({ competitionData, oddBackground }) => {
  const {
    'competitionName': Competition,
    'season' : Saison,
    'checkResult' : checkedResult,
    'teams': Teams,
    'DBSuccess' : ImportFlag,
    'DBMessage' : ImportErrorMsg

  } = competitionData;

  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: oddBackground ? '#d0d0d075' : 'transparent',
          borderBottom: '2px solid #80808070',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
           <div style={{ paddingRight: '10px', display:'flex', alignItems:'center' }}>

           {checkedResult ? (checkedResult === 'create' ?
            <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
            : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}

          <EmojiEventsIcon style={{ color: checkedResult ? (checkedResult === 'create' ? 'green' : 'orange') : 'black' }}/>
            <strong style={{paddingLeft:'10px'}}>{Competition}</strong>
          </div>
          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
          {` (Saison: ${Saison})`}
          </div>
        </div>
        <div>
        {(typeof ImportFlag !== 'undefined' && ImportFlag !== null) ? (
            ImportFlag ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
              <div style={{
                'display': 'flex',
                'alignItems': 'center',
                'color': 'red'
                }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof ImportErrorMsg !== 'undefined' && ImportErrorMsg !== null) ? (
                        <span>{ImportErrorMsg}</span>
                    ) : null}
                </div>
            )
        ) : null}
                </div>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {Teams && Object.entries(Teams).map(([teamKey, teamValue]) => (
            <Typography key={teamKey} style={{display: 'flex', justifyContent: 'space-between'}}>
              <Box display="flex" alignItems="center" padding="8px">
                
                {teamValue?.isHome && (<span style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                  {teamValue.checkResult ? (teamValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
                  <GroupsIcon style={{ color: teamValue.checkResult ? (teamValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }}/><strong style={{ paddingLeft: '10px'}}>Equipe Locale:</strong></span>)}
                
                {teamValue?.isAway && (<span style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                {teamValue.checkResult ? (teamValue.checkResult === 'create' ?
                    <DoneIcon style={{ color: '#009900', paddingRight: '5px' }} /> : <UpdateIcon style={{ color: '#e69500', paddingRight: '5px' }} />) 
                    : <ErrorIcon style={{ color: '#cc0000', paddingRight: '5px' }} />}
                  <GroupsIcon style={{ color: teamValue.checkResult ? (teamValue.checkResult === 'create' ? 'green' : 'orange') : 'black' }} /><strong style={{ paddingLeft: '10px'}}>Equipe Visiteur:</strong></span>)}
                
                <span style={{ marginLeft: '8px' }}>{`${teamValue?.teamName}`}</span>
              </Box>
              {(typeof teamValue.DBSuccess !== 'undefined' && teamValue.DBSuccess !== null) ? (
            teamValue.DBSuccess ? (
                <DoneIcon style={{ color: 'green' }} />
            ) : (
                <div style={{
                  'display': 'flex',
                  'alignItems': 'center',
                  'color': 'red'
                  }}>
                    <ErrorIcon style={{ color: 'red' }} />
                    {(typeof teamValue.DBMessage !== 'undefined' && teamValue.DBMessage !== null) ? (
                        <span>{teamValue.DBMessage}</span>
                    ) : null}
                </div>
            )
        ) : null}
            </Typography>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};


function generateTechnicalId() {
  const timestamp = new Date().getTime();
  const random = Math.floor(Math.random() * 1000); // Valeur aléatoire pour éviter les conflits en cas de création simultanée

  return `${timestamp}-${random}`;
}


const formatExcelDataToMongoModel = (excelData, provider, existingMatchData) => {
  const formattedData = [];

  excelData.forEach((match) => {
    // Générer un ID technique pour mapper les erreurs ou avertissements, émis par l'appel serveur (vérification des doublons)
    match.json_id = generateTechnicalId();
    let formattedMatch = {};
    formattedMatch.json_id = match.json_id;
    formattedMatch.provider = provider;

    formattedMatch.playerFirstName = match['Prénom Joueur'];
    formattedMatch.playerTeamName = match['Equipe Joueur'];
    formattedMatch.playerLastName = match['Nom Joueur']; 
    formattedMatch.playerNumber = match['Numéro Joueur'];

    if (existingMatchData){
      formattedMatch.matchId = existingMatchData._id;
      formattedMatch.competitionId = existingMatchData.competition._id;
      formattedMatch.competitionName = existingMatchData.competition.name;
      formattedMatch.season = existingMatchData.competition.season;
      formattedMatch.day = existingMatchData.day;
      formattedMatch.homeTeamId = existingMatchData.homeTeam._id;
      formattedMatch.awayTeamId = existingMatchData.awayTeam._id;
      formattedMatch.homeTeamName = existingMatchData.homeTeam.name;
      formattedMatch.awayTeamName = existingMatchData.awayTeam.name;
    } else {
      formattedMatch.season = match['Saison'];
      formattedMatch.competitionName = match['Compétition'];
      formattedMatch.day = match['Journée'];
      formattedMatch.homeTeamName = match['Equipe domicile'];
      formattedMatch.awayTeamName = match['Equipe visiteur'];
    }

    //Handle minutes played to create replacement out GF
    formattedMatch.minutes = match['Minutes'];

    formattedData.push(formattedMatch);
  });

  return formattedData;
};

function csvToCompetitionDTO(excelData) {

  // Groupement des données par compétition
  const competitions = {};
  excelData.forEach(row => {
    const { 
      'Provider' : provider,
      'Config' : config,
      'SportId' : sportId, 
      'SportLabel' : sportLabel, 
      'DisciplineId' : disciplineId, 
      'DisciplineLabel' : disciplineLabel,
      'Compétition': competition, 
      'Phase' : phase, 
      'Epreuve' : epreuve, 
      'Catégorie' : category, 
      'Date' : date 
    } = row;

    if (!competitions[competition]) {
      competitions[competition] = {
        provider,
        name: competition,
        idNameConfig : config,
        competitionsDisciplines: []
      };
    }

    const competitionDisciplines = competitions[competition].competitionsDisciplines;
    let competitionDiscipline = competitionDisciplines.find(cd => cd.discipline.idName === disciplineId && cd.discipline.sport.idName === sportId);

    if (!competitionDiscipline) {
      competitionDiscipline = {
        discipline: { idName: disciplineId, label : disciplineLabel, sport : {idName : sportId, label : sportLabel, provider}, provider },
        phases: [],
        provider
      };
      competitionDisciplines.push(competitionDiscipline);
    }

    let phaseDTO = competitionDiscipline.phases.find(p => p.name === phase && p.category.name === category && p.epreuve.name === epreuve);
    if (!phaseDTO) {
      phaseDTO = {
        name: phase,
        epreuve: { name: epreuve, provider },
        category: { name: category, provider },
        sportEvents: [],
        provider
      };
      competitionDiscipline.phases.push(phaseDTO);
    }

    phaseDTO.sportEvents.push({ date : date, provider });
  });

  // Création des objets DTO
  return Object.values(competitions).map(competition => new CompetitionDTO(competition));
}


const SportEventsCSV = ({ importOption, provider, discipline, match }) => {

    const [loading, setLoading] = useState(false);
    const [showEventAccordion, setShowEventAccordion] = useState(false);
    
    const [excelData, setExcelData] = useState(null);
    const [pastedTableData, setPastedTableData] = useState(null);
    const [checkedData, setCheckedData] = useState(null);
    const [isImportedData, setIsImportedData] = useState(false);
    const [columnMappings, setColumnMappings] = useState({});
    const [mappedColumns, setMappedColumns] = useState({});
    const [isMappingValid, setIsMappingValid] = useState(false);
    const [isColumnMappingModalOpen, setIsColumnMappingModalOpen] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [workbook, setWorkbook] = useState(null);
    const [headerRow, setHeaderRow] = useState([]);
    const [importSummary, setImportSummary] = useState(null);

    // Extract common columns and data // removed , 'Points' for now
    let commonColumnsCreation = [
      'Provider',
      'Config',
      'SportId',
      'SportLabel',
      'DisciplineId',
      'DisciplineLabel',
      'Compétition',
      'Phase',
      'Epreuve',
      'Catégorie',
      'Date'
    ];

    const commonColumns = commonColumnsCreation;
    //removed , 'Points' for now
    const requiredColumns = commonColumnsCreation.filter(column => !['Stade', 'Localisation'].includes(column));

    const handleNextAction = async () => {

      setShowEventAccordion(false);

         // Show loading indicator
         setLoading(true);

         const competitionsDTO = csvToCompetitionDTO(excelData)

         try {
          // Envoyer les competitions DTO

          const response = await postV2Competitions(competitionsDTO)

          console.log(response)
          //setCheckedData({matches: data.matches, competitions: data.competitions, teams: data.teams});

      } catch (error) {
          console.error('error', error, error.message);
          //TODO setResponse([error.message]);
      }
         setLoading(false);
    };


    const handleImportAction = async () => {
      console.log(checkedData)

      setShowEventAccordion(false);
      
         // Show loading indicator
         setLoading(true);

         try {
          const { data } = await importMatches({matches: checkedData.matches, competitions: checkedData.competitions, teams: checkedData.teams},discipline,'DSAS');
          setCheckedData({matches: data.matches, competitions: data.competitions, teams: data.teams, message: data.message});
          setImportSummary(data.importSummary);
          setIsImportedData(true);
      } catch (error) {
          console.error('error', error, error.message);
          //TODO setResponse([error.message]);
      }
         setLoading(false);
    };


    const handleExcelData = () => {
      setShowEventAccordion(true);
    };
    
  
    const openColumnMappingModal = () => {
      setIsColumnMappingModalOpen(true);
      setShowEventAccordion(false);
    };
  
    const handleColumnMappingChange = (newMappings, newIndexMappings, isValid) => {
      // Set mapping
      setColumnMappings(newMappings);
      setMappedColumns(newIndexMappings);
      // Validation state update
      setIsMappingValid(isValid);
      // Close the modal after applying mappings
      setIsColumnMappingModalOpen(false); 
      setShowEventAccordion(true);
    };

    const onDrop = (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
  
      reader.onload = (e) => {
        
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        setWorkbook(workbook);

        // Data is in the first sheet (to confirm)
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        
        // Extract the header row
        const headerRow = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0];
        setHeaderRow(headerRow);
  
        // Open the column mapping modal before processing the data
        openColumnMappingModal();
      };
  
      reader.readAsArrayBuffer(file);
    };

    const onPaste = (pastedTableData) => {

      if (pastedTableData){
        const headerRow = pastedTableData[0];
        setHeaderRow(headerRow);
        openColumnMappingModal();
        setPastedTableData(pastedTableData);
      }
  
    };

    const serialToDate = (serial) => {
      const utc_days  = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;  
      const date_info = new Date(utc_value * 1000);
    
      const fractional_day = serial - Math.floor(serial) + 0.0000001;
    
      let total_seconds = Math.floor(86400 * fractional_day);
    
      const seconds = total_seconds % 60;
      total_seconds -= seconds;
    
      const hours = Math.floor(total_seconds / (60 * 60));
      const minutes = Math.floor(total_seconds / 60) % 60;
    
      return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    };

  const processData = (sheet,isCSV) => {
    
  const data = isCSV ? XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, defval: ''}) : sheet;
  const processedData = data.slice(1).map((row) => {
  const commonData = {};

      commonColumns.forEach((col, index) => {
        let value = row[mappedColumns[col]];
        // Vérifier si la colonne est une date
        
        if (["Date"].includes(col)) {
          // Supposer que value est un nombre sériel Excel pour une date
          value = serialToDate(value);
        }
        commonData[col] = value;
      });

      return {
        ...commonData,
      };
    });

    return processedData;
  };

  useEffect(() => {
    // Process the file if mappings are present and the modal is closed
    if (Object.keys(mappedColumns).length > 0 && !isColumnMappingModalOpen && !isProcessing && workbook) {
      setIsProcessing(true);

      // Process sheet data
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const processedData = processData(sheet, true);

      //Construction des DTO
      console.log(processedData)

      setExcelData(processedData);
      setIsProcessing(false);
    }
    // Process the pasted data if mappings are present and the modal is closed
    if (Object.keys(mappedColumns).length > 0 && !isColumnMappingModalOpen && !isProcessing && pastedTableData) {
      setIsProcessing(true);

      const processedData = processData(pastedTableData, false);

      setExcelData(processedData);
      setIsProcessing(false);
    }
  }, [mappedColumns, isColumnMappingModalOpen, isProcessing, workbook]);


const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div>
      {importOption ==='dropzone' && !isColumnMappingModalOpen && !showEventAccordion  && !loading && (
      <div {...getRootProps()} style={dropzoneStyles}>
        <input {...getInputProps()} />
        <p>Glissez-déposez un fichier Excel ici, ou cliquez pour en sélectionner un</p>
      </div>
      )}
      {importOption ==='copy-paste' && !isColumnMappingModalOpen && !showEventAccordion  && !loading && (
      <div>
        <PasteTableComponent onProcessData={onPaste}/>
      </div>
      )}

      {/* Column Mapping */}
      {isColumnMappingModalOpen && (
        <ColumnMappingComponent
          commonColumns={commonColumns}
          requiredColumns={requiredColumns}
          onColumnMappingChange={handleColumnMappingChange}
          prevColumnMapping={columnMappings}
          prevMappedColumns={mappedColumns}
          headerRow={headerRow}
          showInfoMsg={true}
        />
      )}

      {/* Loading indicator */}
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
          <CircularProgress />
        </div>
      )}

      {showEventAccordion && (
        <div style={{display: 'flex',
          justifyContent: 'space-between', paddingTop:'20px', paddingBottom:'20px'}}>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={() => openColumnMappingModal()}>Modifier le mapping</button>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={handleNextAction}>Lancer la vérification</button>
        </div>
      )}

      {!isImportedData && checkedData &&  (
        <div style={{display: 'flex',
          justifyContent: 'space-between', paddingTop:'20px', paddingBottom:'20px'}}>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={() => handleExcelData()}>Retour</button>
          <button  style={{
            padding: '10px',
            borderRadius: '5px',
            background: '#0A76B9',
            color: 'white',
            cursor: 'pointer'
          }} onClick={handleImportAction}>Importer les données</button>
        </div>
      )}

 
      {/*Step 1 - Sheet read result*/}
      {showEventAccordion && excelData && (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <div style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px' }}>{'Aperçu de lecture'}</h2>
            <span>
              Ceci est un aperçu de la lecture de votre fichier ligne par ligne. Cliquez sur "lancer la vérification" pour commencer le traitement et comparer l'existant en base de données.
              {JSON.stringify(checkedData)}
            </span>
          </div>
          {excelData.map((event, index) => (
            <EventAccordion key={index} eventData={event} oddBackground={index % 2 === 1} />
          ))}
        </div>
      )}

        {/*Step 2 - First DB check for import & logic*/}
        {!isImportedData && checkedData && (<div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <h2 style={{ marginBottom: '20px' }}>{'Traitement des données'}</h2>
              <span>
                Ceci est un aperçu du traitement de vos données, telles qu'elles seront importées. Cliquez sur "importer les données" pour procéder à l'import en base de données.
              </span>
        </div>)}

        {isImportedData && checkedData && importSummary && (
        <ImportResume importSummary={importSummary} />
      )}

      {/*Légende résultat de check / imports*/}
      {!isImportedData && checkedData &&
        <Legend/>}


      {/*Compétitions à vérifier pour import*/}
      { checkedData && checkedData.competitions &&
        <div style={{paddingTop: '25px', paddingBottom: '25px'}}>
          <div>
            <h3>Compétitions</h3>
          </div>
          <div style={{paddingTop: '10px'}}>
            {Object.entries(checkedData.competitions).map(([competitionKey, competitionData], index) => (
              <CompetitionsAccordionCheckData key={index} competitionData={competitionData} oddBackground={index % 2 === 1} />
            ))}
          </div>
        </div>
      }
      
    </div>
  );
      }


export default SportEventsCSV;